import {
  SET_TEMPLATES,
  SET_SHARED_TEMPLATES,
  CLEAR_SHARED_TEMPLATES,
  ADD_NEW_TEMPLATE,
  UPDATE_DESIGN_TEMPLATE,
  RESET_UNDO_REDO,
  SET_DESIGN_TEMPLATE,
  ADD_LAYER,
  UPDATE_LAYER,
  UPDATE_ZOOM,
  SET_INITIAL_TEMPLATE_SIZING,
  UPDATE_LAYERS,
  SET_SELECTED_LAYER_ID,
  UPDATE_TEMPLATE,
  DELETE_TEMPLATE,
  UPDATE_TEMPLATE_SETTINGS,
  UPDATE_LAYER_COLOR,
  ADJUST_FAVORITE_COUNT,
  CLEAR_TEMPLATES_DATA,
  UPDATE_FONT_SIZE,
  APPEND_TEMPLATES,
  APPEND_STANDARD_TEMPLATES,
  REMOVE_SHARED_TEMPLATE,
  SET_IS_LOADING_USER_TEMPLATES,
  SET_STANDARD_TEMPLATES,
  SET_LOADING_STANDARD_TEMPLATES,
  SET_TEMPLATE_CATEGORIES,
  SET_TEMPLATE_PACKS,
  SET_ERRORS,
} from "../types";

import axios from "axios";
import { ActionCreators } from "redux-undo";
import { removeFromTemplateSelections } from "./designActions";

export const addNewTemplate = (newTemplate) => (dispatch) => {
  return new Promise((resolve, reject) => {
    axios
      .post("/api/templates/addNewTemplate", newTemplate)
      .then((res) => {
        dispatch({ type: ADD_NEW_TEMPLATE, payload: res.data });
        dispatch({ type: RESET_UNDO_REDO, payload: {} });
        dispatch({ type: SET_DESIGN_TEMPLATE, payload: res.data });
        resolve(res.data);
      })
      .catch((err) => {
        console.log(err);
        reject("Failure");
      });
  });
};

export const getUserTemplates = (lastTemplateId) => (dispatch) => {
  dispatch({
    type: SET_IS_LOADING_USER_TEMPLATES,
    payload: true,
  });

  return new Promise((resolve, reject) => {
    axios
      .get(`/api/templates?lastTemplateId=${lastTemplateId}`)
      .then((res) => {
        if (lastTemplateId == "None") {
          dispatch({ type: SET_TEMPLATES, payload: res.data });
        } else {
          dispatch({ type: APPEND_TEMPLATES, payload: res.data });
        }

        dispatch({
          type: SET_IS_LOADING_USER_TEMPLATES,
          payload: false,
        });

        resolve(res.data);
      })
      .catch((err) => {
        console.error("Unable to get user templates: ", err);
        dispatch({
          type: SET_IS_LOADING_USER_TEMPLATES,
          payload: false,
        });

        reject("Unable to get user templates: ", err);
      });
  }).catch((err) => {
    console.error("Promise failed: Failed to getUserTemplates: ", err);
  });
};

export const setUserTemplates = (newUserTemplates) => (dispatch) => {
  dispatch({ type: SET_TEMPLATES, payload: newUserTemplates });
};

export const clearSharedTemplates = () => (dispatch) => {
  dispatch({ type: CLEAR_SHARED_TEMPLATES });
};

export const getTemplateCategories = () => (dispatch) => {
  return new Promise((resolve, reject) => {
    axios
      .get("/api/templates/categories/getTemplateCategories")
      .then((res) => {
        dispatch({ type: SET_TEMPLATE_CATEGORIES, payload: res.data });
        resolve(res.data);
      })
      .catch((err) => {
        console.error("Unable to get templatecategories: ", err);
        reject("Unable to get templatecategories: ", err);
      });
  });
};

export const addTemplateCategory = (category) => (dispatch) => {
  axios
    .post("/api/templates/categories/addTemplateCategory", category)
    .then((res) => {
      dispatch(getTemplateCategories());
    })
    .catch((err) => {
      console.error("Unable to add template category: ", err);
      dispatch({
        type: SET_ERRORS,
        payload: `Unable to add template category: ${err}`,
      });
    });
};

// deleteTemplateCategory
export const deleteTemplateCategory = (category) => (dispatch) => {
  return new Promise((resolve, reject) => {
    axios
      .delete(`/api/templates/categories/deleteTemplateCategory/${category}`)
      .then((res) => {
        dispatch(getTemplateCategories());
        resolve();
      })
      .catch((err) => {
        console.error("Unable to delete template category: ", err);
        dispatch({
          type: SET_ERRORS,
          payload: `Unable to delete template category: ${err}`,
        });
        reject(`Unable to delete template category: ${err}`);
      });
  });
};

export const updateTemplateCategory = (categoryUpdate) => (dispatch) => {
  return new Promise((resolve, reject) => {
    axios
      .put(`/api/templates/categories/updateTemplateCategory`, categoryUpdate)
      .then((res) => {
        dispatch(getTemplateCategories());
        resolve();
      })
      .catch((err) => {
        console.error("Unable to update template category: ", err);
        dispatch({
          type: SET_ERRORS,
          payload: `Unable to update template category: ${err}`,
        });
        reject(`Unable to update template category: ${err}`);
      });
  });
};

// Template Pack Actions
export const getTemplatePacks = () => (dispatch) => {
  return new Promise((resolve, reject) => {
    axios
      .get("/api/templates/packs/getTemplatePacks")
      .then((res) => {
        dispatch({ type: SET_TEMPLATE_PACKS, payload: res.data });
        resolve(res.data);
      })
      .catch((err) => {
        console.error("Unable to get template packs: ", err);
        reject("Unable to get template packs: ", err);
      });
  });
};

export const addTemplatePack = (pack) => (dispatch) => {
  axios
    .post("/api/templates/packs/addTemplatePack", pack)
    .then((res) => {
      dispatch(getTemplatePacks());
    })
    .catch((err) => {
      console.error("Unable to add template pack: ", err);
      dispatch({
        type: SET_ERRORS,
        payload: `Unable to add template pack: ${err}`,
      });
    });
};

export const deleteTemplatePack = (pack) => (dispatch) => {
  return new Promise((resolve, reject) => {
    axios
      .delete(`/api/templates/packs/deleteTemplatePack/${pack}`)
      .then((res) => {
        dispatch(getTemplatePacks());
        resolve();
      })
      .catch((err) => {
        console.error("Unable to delete template pack: ", err);
        dispatch({
          type: SET_ERRORS,
          payload: `Unable to delete template pack: ${err}`,
        });
        reject(`Unable to delete template pack: ${err}`);
      });
  });
};

export const updateTemplatePack = (packUpdate) => (dispatch) => {
  return new Promise((resolve, reject) => {
    axios
      .put(`/api/templates/packs/updateTemplatePack`, packUpdate)
      .then((res) => {
        dispatch(getTemplatePacks());
        resolve();
      })
      .catch((err) => {
        console.error("Unable to update template pack: ", err);
        dispatch({
          type: SET_ERRORS,
          payload: `Unable to update template pack: ${err}`,
        });
        reject(`Unable to update template pack: ${err}`);
      });
  });
};

export const getSharedTemplates = (lastTemplateId) => (dispatch) => {
  return new Promise((resolve, reject) => {
    axios
      .get(
        `/api/templates/sharedTemplates/getSharedTemplates?lastTemplateId=${lastTemplateId}`
      )
      .then((res) => {
        dispatch({ type: SET_SHARED_TEMPLATES, payload: res.data });
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
        console.error(err);
      });
  });
};

export const getTemplate = (templateId) => (dispatch) => {
  return new Promise((resolve, reject) => {
    axios
      .get(`/api/template/${templateId}`)
      .then((res) => {
        dispatch({ type: RESET_UNDO_REDO, payload: {} });
        dispatch({ type: SET_DESIGN_TEMPLATE, payload: res.data });
        resolve(res.data);
      })
      .catch((err) => {
        console.error(err);
        reject(err);
      });
  });
};

export const saveTemplate = (template) => (dispatch) => {
  return new Promise((resolve, reject) => {
    axios
      .post("/api/templates/updateTemplate", template)
      .then((res) => {
        //console.log("Saved template");
        resolve("Success");
      })
      .catch((err) => {
        console.log(err);
        reject(err);
      });
  });
};

export const updateDesignTemplate = (newValues) => (dispatch) => {
  dispatch({ type: UPDATE_DESIGN_TEMPLATE, payload: newValues });
};

export const addLayer = (layer) => (dispatch) => {
  dispatch({ type: ADD_LAYER, payload: layer });
  dispatch({ type: SET_SELECTED_LAYER_ID, payload: layer.id });
};

export const updateLayer = (layerId, updateValues) => (dispatch) => {
  dispatch({ type: UPDATE_LAYER, payload: { layerId, updateValues } });
};

// I created a seperate updateFontSizeAction so that it can be excluded from the undo/redo history
export const updateFontSize = (layerId, fontSize) => (dispatch) => {
  dispatch({ type: UPDATE_FONT_SIZE, payload: { layerId, fontSize } });
};

export const updateLayerColor = (layerId, updateValues) => (dispatch) => {
  dispatch({ type: UPDATE_LAYER_COLOR, payload: { layerId, updateValues } });
};

export const updateLayers = (layers) => (dispatch) => {
  dispatch({ type: UPDATE_LAYERS, payload: layers });
};

export const updateZoom = (zoom) => (dispatch) => {
  dispatch({ type: UPDATE_ZOOM, payload: zoom });
};

export const setInitialTempateSizing = (isResizing) => (dispatch) => {
  dispatch({ type: SET_INITIAL_TEMPLATE_SIZING, payload: isResizing });
};

export const renameLayer = (layer, newName) => (dispatch) => {
  dispatch({
    type: UPDATE_LAYER,
    payload: { layerId: layer.id, updateValues: { name: newName } },
  });
};

export const duplicateLayer = (layer) => (dispatch) => {
  let newLayerId = Math.random().toString(36).substr(2, 9);
  dispatch({
    type: ADD_LAYER,
    payload: {
      ...layer,
      name: layer.name + " (copy)",
      id: newLayerId,
      x: layer.x + 20,
      y: layer.y + 20,
    },
  });

  dispatch({ type: SET_SELECTED_LAYER_ID, payload: newLayerId });
};

export const deleteLayer = (layer, layers) => (dispatch) => {
  let newLayers = layers.filter((l) => l.id !== layer.id);
  dispatch({ type: UPDATE_LAYERS, payload: newLayers });

  dispatch({ type: SET_SELECTED_LAYER_ID, payload: "" });
};

export const setSelectedLayerId = (layerId) => (dispatch) => {
  dispatch({ type: SET_SELECTED_LAYER_ID, payload: layerId });
};

export const renameTemplate = (template, newName) => (dispatch) => {
  let newTemplate = { ...template, title: newName };

  saveTemplate(newTemplate)(dispatch);

  dispatch({
    type: UPDATE_TEMPLATE,
    payload: {
      templateId: template.templateId,
      updateValues: { title: newName },
    },
  });
};

export const duplicateTemplate = (template) => (dispatch) => {
  return new Promise((resolve, reject) => {
    let newTemplate = {
      ...template,
      title: template.title + " (copy)",
      categories: [], // Do not copy categories
      templatePacks: [], // Do not copy templatePacks
      isStandardTemplate: false, // Do not copy isStandardTemplate
    };
    delete newTemplate.templateId;

    axios
      .post("/api/templates/addNewTemplate", newTemplate)
      .then((res) => {
        dispatch({ type: ADD_NEW_TEMPLATE, payload: res.data });
        resolve(res.data);
      })
      .catch((err) => {
        console.log(err);
        reject(err);
      });
  });
};

export const deleteTemplate = (templateId) => (dispatch) => {
  axios
    .delete(`/api/template/${templateId}`)
    .then((res) => {
      dispatch({ type: DELETE_TEMPLATE, payload: templateId });
      dispatch(getUserTemplates("None"));

      // Remove template from templateSelections
      dispatch(removeFromTemplateSelections(templateId));
    })
    .catch((err) => {
      console.log(err);
    });
};

export const updateTemplateSettings = (updateValues) => (dispatch) => {
  dispatch({ type: UPDATE_TEMPLATE_SETTINGS, payload: updateValues });
};

export const undo = () => (dispatch) => {
  dispatch(ActionCreators.undo());
  dispatch({ type: SET_SELECTED_LAYER_ID, payload: null });
};

export const redo = () => (dispatch) => {
  dispatch(ActionCreators.redo());
  dispatch({ type: SET_SELECTED_LAYER_ID, payload: null });
};

export const adjustFavoriteCount = (templateId, adjustment) => (dispatch) => {
  dispatch({
    type: ADJUST_FAVORITE_COUNT,
    payload: { templateId, adjustment },
  });
};

export const clearTemplatesData = () => (dispatch) => {
  dispatch({ type: CLEAR_TEMPLATES_DATA });
};

export const unshareTemplate = (templateId) => (dispatch) => {
  axios
    .post("/api/templates/unshareTemplate", { templateId })
    .then((res) => {
      // Remove template from shared templates

      dispatch({ type: REMOVE_SHARED_TEMPLATE, payload: templateId });
    })
    .catch((err) => {
      console.error("Unable to unshare template: ", err);
      dispatch({ type: SET_ERRORS, payload: err });
    });
};

export const getStandardTemplates = () => (dispatch) => {
  dispatch({ type: SET_LOADING_STANDARD_TEMPLATES, payload: true });

  axios
    .get("/api/templates/standardTemplates")
    .then((res) => {
      dispatch({ type: SET_STANDARD_TEMPLATES, payload: res.data });
      dispatch({ type: SET_LOADING_STANDARD_TEMPLATES, payload: false });
    })
    .catch((err) => {
      console.log("Error getting standard templates: ", err);
      dispatch({ type: SET_LOADING_STANDARD_TEMPLATES, payload: false });
    });
};

export const setStandardTemplates = (standardTemplates) => (dispatch) => {
  dispatch({ type: SET_STANDARD_TEMPLATES, payload: standardTemplates });
};

export const addTemplateSelectionsToStandardTemplates =
  (templateSelections) => (dispatch) => {
    // Get the full templates

    return new Promise((resolve, reject) => {
      if (
        // If doesnt exist
        templateSelections == null ||
        templateSelections == undefined ||
        templateSelections.length == 0
      ) {
        resolve([]);
      } else {
        axios
          .post(`/api/templates/getTemplateSet`, {
            templateSet: templateSelections,
          })
          .then((res) => {
            dispatch({ type: APPEND_STANDARD_TEMPLATES, payload: res.data });
            resolve(res.data);
          })
          .catch((err) => {
            console.error(
              "Unable to get addTemplateSelectionsToStandardTemplates: ",
              err
            );

            reject(
              "Unable to get addTemplateSelectionsToStandardTemplates: ",
              err
            );
          });
      }
    });
  };

export const getRecentlyUpdatedUserTemplates = () => (dispatch) => {
  return new Promise((resolve, reject) => {
    axios
      .get(`/api/userTemplates/recentlyUpdatedTemplates`)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        console.error("Unable to get getRecentlyUpdatedUserTemplates: ", err);

        reject("Unable to get getRecentlyUpdatedUserTemplates: ", err);
      });
  });
};
